// Hjälpfunktioner för Web Push (VAPID) — frontend.
import { api } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export const pushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function getPermissionStatus() {
  if (!pushSupported()) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function enablePush() {
  if (!pushSupported()) throw new Error('Push stöds inte i denna webbläsare');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Tillstånd nekat');

  const { data } = await api.getVapidPublicKey();
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await api.pushSubscribe({
    endpoint: json.endpoint,
    keys: json.keys,
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const sub = await getCurrentSubscription();
  if (sub) {
    const json = sub.toJSON();
    try {
      await api.pushUnsubscribe({ endpoint: json.endpoint, keys: json.keys });
    } catch (_) {}
    await sub.unsubscribe();
  }
}

export async function sendTestPush() {
  return api.pushTest();
}
